import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { injectIntl } from 'react-intl'
import { RichTextArea } from '../../richtext'
import { get } from 'lodash'

@form({
  form: 'update-report-modal',
  disableHook: true
})
@injectIntl
class UpdateReportModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    onUpdateReport: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    reportId: PropTypes.number.isRequired
  }

  componentWillReceiveProps(nextProps = {}) {
    const { reportId } = this.props

    if (reportId !== get(nextProps, 'reportId')) {
      this.initForm(nextProps)
    }
  }

  initForm = data => {
    const initObj = {
      fields: get(data, 'fields'),
      recentUpdates: get(data, 'recentUpdates'),
      id: get(data, 'reportId')
    }

    this.props.initialize(initObj)
  }

  render() {
    const {
      modalId,
      modal,
      handleSubmit,
      onUpdateReport,
      reportId,
      isLoading
    } = this.props



    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="title.update_report">
          Update report
        </Title>
        <Form
            className="form"
            onSubmit={handleSubmit((fields) =>
                onUpdateReport(reportId, fields)
            )}
        >
            <div className="row">
              <div className="col-xs-12">
                <RichTextArea label="Fields"  intlKey="label.fields" name="fields" isInitialized={true}/>
              </div>
            </div>

          <div className="row">
            <div className="col-xs-12">
              <RichTextArea label="Recent updates"  intlKey="label.recentUpdates" name="recentUpdates" isInitialized={true}/>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <Button
                  intlKey="button.dismiss"
                  onClick={() => this.props.modal(null)}
                  secondary
                  type="button"
                  style={{ marginRight: 10 }}
              >
                Dismiss
              </Button>
            </div>
          <div className="col-xs-6 text--right">
              <Button
                  intlKey="button.update"
                  type="submit"
                  isLoading={isLoading ? true : undefined}
              >
                Update
              </Button>
            </div>

          </div>



        </Form>
      </Modal>
    )
  }
}

export default UpdateReportModal
